import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import settingServiceSelectors from '../selectors';
import settingServiceActions from '../actions';

const useGetPackageProgramList = (lazy?: boolean) => {
  const dispatch = useAppDispatch();
  const data = settingServiceSelectors.getPackageProgramList();

  const mutate = () => {
    dispatch(settingServiceActions.getPackageProgramList.fetch());
  };

  useEffect(() => {
    if (!lazy) {
      mutate();
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetPackageProgramList;
